import React, { useContext, useEffect, useState } from "react";
import PriceListItem from "../../components/PriceListItem/PriceListItem";
import { UserContext } from "../../contexts/userContext";
import { Button, Modal, Navbar } from "../../components";
import styles from "./Pricing.module.css";
import Login from "../Auth/Login/Login";
import Signup from "../Auth/Signup/Signup";
import { useSearchParams } from "react-router-dom";

function loadPaymentButton(payment_button_id) {
  const script = document.createElement("script");

  script.src = "https://checkout.razorpay.com/v1/payment-button.js";
  script.setAttribute("data-payment_button_id", payment_button_id);
  script.async = true;

  document.getElementById(payment_button_id)?.appendChild(script);
  return script;
}

function Pricing() {
  const { user } = useContext(UserContext);
  const [searchParams, setSearchParams] = useSearchParams();

  const [showModal, toggleModal] = useState(false);

  const auth = searchParams.get("auth");

  useEffect(() => {
    if (user && showModal) {
      handleModalClose();
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      const script = loadPaymentButton("pl_Jcym90Qx93eyAk");
      const script2 = loadPaymentButton("pl_KsXvYrDOtNAxFl");
      const script3 = loadPaymentButton("pl_KsXzA2VuFqCQjc");

      return () => {
        document.getElementById("monthly")?.removeChild(script);
        document.getElementById("monthly")?.removeChild(script2);
        document.getElementById("monthly")?.removeChild(script3);
      };
    }
  }, [user]);

  const handleModalClose = () => {
    toggleModal(false);
    setSearchParams({});
  };
  return (
    <>
      <Navbar />
      <div className={styles.ContainerWrapper} style={{ marginTop: 100 }}>
        <div className={styles.section_title_wrapper}>
          <span>Resume For All</span>
          <h2>Pricing Plans</h2>
        </div>
        <div className={styles.row}>
          <div className={styles.pricing_table}>
            <div className={styles.PricingHead}>
              <h2>Monthly Plan</h2>
              <p>Get started and make your resume now</p>
            </div>
            <div className={styles.PricingPrice}>
              <span>&#8377; 75</span>
              <p>For 1 month</p>
            </div>
            <div className={styles.PricingButton}>
              {user ? (
                <form id="pl_Jcym90Qx93eyAk"></form>
              ) : (
                <Button
                  content="Login to buy"
                  onClick={() => toggleModal(true)}
                />
              )}
            </div>
            <div>
              <PriceListItem content="1 Resume" />
              <PriceListItem content="30 Downloads per month" />
              <PriceListItem content="5 Premium Designs" />
              <PriceListItem content="ATS Resumes" no />
              <PriceListItem content="Custom Color Themes" />
              <PriceListItem content="No Automatic Renewal" />
              <PriceListItem content="Chat Support" />
            </div>
          </div>
          <div className={styles.pricing_table}>
            <div className={styles.popularTag}>Most Popular</div>
            <div className={styles.PricingHead}>
              <h2>Quarterly Plan</h2>
              <p>Most popular plan among students as well as professionals</p>
            </div>
            <div className={styles.PricingPrice}>
              <span>&#8377; 175</span>
              <p>for 3 months</p>
            </div>
            <div className={styles.PricingButton}>
              {user ? (
                <form id="pl_KsXvYrDOtNAxFl"></form>
              ) : (
                <Button
                  content="Login to buy"
                  onClick={() => toggleModal(true)}
                />
              )}
            </div>
            <div className={styles.PricingList}>
              <PriceListItem content="5 Resumes" />
              <PriceListItem content="100 Downloads per month" />
              <PriceListItem content="10 Premium Designs" />
              <PriceListItem content="Dedicated ATS Resumes" />
              <PriceListItem content="Custom Color Themes" />
              <PriceListItem content="No Automatic Renewal" />
              <PriceListItem content="Priority Customer Support" />
            </div>
          </div>
          <div className={styles.pricing_table}>
            <div className={styles.PricingHead}>
              <h2>Yearly Plan</h2>
              <p>Get access to all premium features with no limits. Period.</p>
            </div>
            <div className={styles.PricingPrice}>
              <span>&#8377; 625</span>
              <p>for 12 months</p>
            </div>
            <div className={styles.PricingButton}>
              {user ? (
                <form id="pl_KsXzA2VuFqCQjc"></form>
              ) : (
                <Button
                  content="Login to buy"
                  onClick={() => toggleModal(true)}
                />
              )}
            </div>
            <div className="PricingList">
              <PriceListItem content="Unlimited Resumes" />
              <PriceListItem content="Unlimited Downloads" />
              <PriceListItem content="All Premium Designs" />
              <PriceListItem content="Dedicated ATS Resumes" />
              <PriceListItem content="Custom Color Themes" />
              <PriceListItem content="No Automatic Renewal" />
              <PriceListItem content="Priority Customer Support" />
            </div>
          </div>
        </div>
      </div>
      <img
        src="https://cdn.razorpay.com/static/assets/pay_methods_branding.png"
        width={250}
        style={{ display: "block", margin: "1em auto" }}
      />
      <p className={styles.card_disclaimer}>
        We accept all major payment methods and process payments with Razorpay
        SSL Secure / 256-bit SSL secure checkout. 3-Day Money Back Guarantee.
      </p>
      <section id="testimonial" class={styles.testimonialSectionWrapper}>
          <div class={styles.ContainerWrapper}>
            <div class={styles.section_title_wrapper}>
              <span>INSPIRATION FROM CUSTOMERS</span>
              <h2>What our users say about us</h2>
            </div>
            <div class="TestimonialWrapper">
              <div class={styles.row} style={{alignItems:'stretch'}}>
                <div class={styles.TestimonialItem}>
                  <div class={styles.TestimonialItemInner}>
                    <h3>Abhay</h3>
                    <p>Product Management</p>
                    <p class={styles.TextWrapper}>
                      I couldn't believe the value for money that this resume builder offers. The pricing is incredibly affordable. I got a top-notch resume at a fraction of the price of other resume builders. Highly recommend it!
                    </p>
                  </div>
                </div>
                <div class={styles.TestimonialItem}>
                  <div class={styles.TestimonialItemInner}>
                    <h3>Jaya</h3>
                    <p>Marketing</p>
                    <p class={styles.TextWrapper}>
                      I highly recommend BigResume for its cost-effective pricing. I was thrilled to find a solution that didn't compromise on quality. It's an excellent investment for anyone looking to create an impressive resume without spending a fortune.
                    </p>
                  </div>
                </div>
                <div class={styles.TestimonialItem}>
                  <div class={styles.TestimonialItemInner}>
                    <h3>Rohan</h3>
                    <p>Teacher</p>
                    <p class={styles.TextWrapper}>
                      This resume maker exceeded my expectations, especially in terms of pricing. I compared several options in the market, and this one offered the best value for money. It's a game-changer for job seekers on a budget!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      <section className={styles.faq_section}>
        <div className={styles.ContainerWrapper}>
          <div className={styles.section_title_wrapper}>
            <span>FREQUENTLY ASKED QUESTIONS</span>
            <h2>Want to ask something about us ?</h2>
          </div>
          <div>
            <div className={styles.reusecore__accordion}>
              <div className={styles.accordion__item}>
                <h2>Will my Premium account renew automatically?</h2>
                <p>
                  No, we do not follow subscription based model. You will never
                  be charged automatically. Ever.
                </p>
              </div>
              <div className={styles.accordion__item}>
                <h2>Is there a money back guarantee?</h2>
                <p>
                  We belive in 100% customer satisfaction. In case you don't
                  feel value for your money, our support team will be glad to
                  help you with your claims.
                </p>
              </div>
              <div className={styles.accordion__item}>
                <h2>Are there any hidden costs?</h2>
                <p>
                  There are absolutely no hidden costs at all. The total price
                  that needs to be paid as per the plan selected, will be
                  visible on your screen before making the payment.
                </p>
              </div>
              <div className={styles.accordion__item}>
                <h2>Can i access my resumes after the premium plan expires?</h2>
                <p>
                  All your resumes and information will be saved securely in your
                  account. You can access even after premium plan expires. You
                  will however not be able to create new resumes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Modal
        active={showModal}
        onClose={handleModalClose}
        style={{ background: "transparent", textAlign: "left" }}
      >
        {auth == "login" ? <Login modal /> : <Signup modal />}
      </Modal>
    </>
  );
}

export default Pricing;
